import { createImageCrop } from '../../utils/imageCrop.js';

export const bindMediaCropPanel = ({
    viewportEl,
    imageEl,
    zoomEl,
    outputWidth,
    outputHeight,
    mimeType = 'image/webp',
    quality = 0.9
}) => {
    let crop = null;

    const destroy = () => {
        if (!crop) return;
        crop.destroy();
        crop = null;
    };

    const load = async (src) => {
        destroy();
        crop = createImageCrop({
            viewportEl,
            imageEl,
            zoomEl,
            outputWidth,
            outputHeight,
            mimeType,
            quality
        });
        await crop.load(src);
        requestAnimationFrame(() => crop?.measureAndFit?.());
        return crop;
    };

    const exportDataUrl = async (overrides = {}) => {
        if (!crop) throw new Error('No crop loaded');
        return crop.exportCrop(overrides);
    };

    const exportSourceRect = () => {
        if (!crop) throw new Error('No crop loaded');
        return crop.exportSourceRect();
    };

    return {
        load,
        exportDataUrl,
        exportSourceRect,
        destroy,
        get active() {
            return Boolean(crop);
        }
    };
};
